import React from "react";
import { cn } from "../../utils/cn";

interface CharCounterProps {
  current: number;
  /** Limite de exibição recomendado pela plataforma — ultrapassar só gera aviso (âmbar), não bloqueia. */
  recommended?: number;
  /** Limite técnico real (API/formulário) — ultrapassar bloqueia o avanço e fica vermelho. */
  hard?: number;
}

// Contador de caracteres para usar como `labelRight` em Input/Textarea, ao
// lado de campos com limite documentado pela plataforma de destino. Some
// fields have both a soft "recommended" length (display truncation, like
// Meta's "ver mais") and a hard technical ceiling (API rejects it) — only
// the hard one blocks navigation (see `canGoNext` in AdsContext); the
// recommended one is purely advisory (amber).
const CharCounter: React.FC<CharCounterProps> = ({
  current,
  recommended,
  hard,
}) => {
  const target = recommended ?? hard;
  const isOverHard = hard !== undefined && current > hard;
  const isOverRecommended = target !== undefined && current > target;
  const denominator = isOverHard ? hard : target;

  if (denominator === undefined) return null;

  return (
    <span
      className={cn(
        "text-[10px] font-bold tabular-nums",
        isOverHard
          ? "text-red-500"
          : isOverRecommended
            ? "text-amber-500"
            : current > 0
              ? "text-emerald-600"
              : "text-gray-400",
      )}
    >
      {current}/{denominator}
    </span>
  );
};

export default CharCounter;
